const SECONDS_PER_ITEM = 72;

export const itemCountForDuration = (minutes: number, availableItems: number) =>
	Math.max(
		1,
		Math.min(availableItems, 50, Math.floor((minutes * 60) / SECONDS_PER_ITEM)),
	);
